<template>
	<div
		class="property-form"
		:class="{ 'shrink': !isVisible, 'bg-color-editing': isUserEditing !== user.id && isUserEditing }">
		<div class="d-flex align-items-start justify-content-between">
			<div v-if="isLoading" class="absolute loader-circle">
				<div class="is-loading"></div>
			</div>
			<!-- loading full screen -->
			<div class="text-center absolute">
				<loading :active.sync="isUploading" :is-full-page="fullPage" :background-color="colorOverlay" :color="colorLoading">
					<template slot="before">
						<div class="absolute text-lg loading-logo">
							<img src="/img/icon-512.png" height="20" width="20" class="d-inline-block align-top" alt="Grafias">
						</div>
					</template>
					<template slot="after">
						<div>
							<div class="text-lg loading-text mb-2">{{ $t('Uploading') }} {{ mediaProgress }}%</div>
							<div class="mt-2">
								<button class="btn btn-cancel " @click="onCancel">Cancel</button>
							</div>
						</div>
					</template>
				</loading>
			</div>
			<div class="property-title">
				{{ $t('Audio Properties') }} - {{  mediaLabel ? mediaLabel.toUpperCase() : 'DEFAULT AUDIO' }}
			</div>
		</div>
		<div class="property-content pr-2" :class="{'pointer-events-none': isLocked ? isLocked.is_locked : true}">
			<div class="form-group mb-5">
				<label class="text-primary">
					{{ $t('Audio File') }}
				</label>
				<label v-if="isCaching" class="ml-2 is-loading"></label>
				<label v-if="isCached" class="ml-2">
					(cached)
					<check-icon :size="15" fillColor="#08ff00" :title="$t('this media is cached and ready for next play!')"></check-icon>
				</label>
				<div class="d-flex flex-row"
				:class="{ 'upload-wrapper-error': !mediaUrl && !mediaFile && !media && isRequired,
				'upload-wrapper': mediaUrl || mediaFile || media || !isRequired }">
				<div class="mt-2 mr-4 pointer" v-if="mediaUrl || mediaFile || media">
					<music-icon></music-icon>
				</div>
				<template v-if="!isUploading && !mediaFile && !media && !mediaUrl" >
					<div class="text-left text-break w-75 mt-4 pointer"
						:class="{'template-center': !mediaFile && !media}">
						<label class="text-underline cur-p text-white">
							<span>Upload</span>
							<input type="file" accept=".mp3,.ogg,.wav" id="audioInputMp" class="hidden" @change="onMediaSelected">
						</label>
						<span> Audio File or Select from </span>
						<span class="text-underline cur-p" @click="openGallery">Gallery</span>
					</div>
				</template>

				<div class="text-left text-break w-75 mt-2 pointer" v-if="isUploading">
						{{ $t('Uploading') }} {{ mediaProgress }}%
				</div>

				<div class="text-left text-break w-75 mt-4 pointer" @click="playPreview()" v-if="media && mediaUrl ==='' && !isUploading">
					{{ media && media.name ? media.name : mediaLabel }}
				</div>

				<div class="text-left text-break w-75 mt-3 pointer" @click="playPreview()"
					v-if="!isUploading && mediaUrl !==''">
					<label class="cur-p text-white ">
						{{ mediaLabel }}
						<input type="file" id="mediaInputMp" accept=".mp3,.ogg,.wav"  class="hidden" @change="onMediaSelected">
					</label>
				</div>
				<div class="vertical-line-audio ml-4 mr-4" v-if="mediaUrl !=='' || media || mediaUrl"></div>
				<div class="d-flex flex-column">
					<div class="pointer pt-2" @click="openGallery" v-if="mediaFile || media || mediaUrl"><i class="material-icons">folder</i></div>
				</div>
			</div>
			<!-- button for upload lyric for audio -->
				<div class="form-group mt-3 mb-1 d-flex">
					<!-- Upload -->
					<label
						:class="{'is-loading': isUploadingAsset, 'disabled': !isUploading && !mediaFile && !media && !mediaUrl}"
						class="btn min-w-100 btn-primary mb-0 mh-36">
						<span v-if="!mediaAssetLabel && !isUploadingAsset" class="text-black">{{ $t('Upload Lyric (.xml or .json)') }}</span>
						<div v-if="mediaAssetLabel && !isUploadingAsset" class="text-black truncate-description-invoice">Uploaded ({{ mediaAssetLabel }})</div>
						<input
							accept=".json, .xml"
							type="file"
							class="hidden"
							@change="onMediaSelectedLyric"
							id="audioLyricInput"
						/>
					</label>
					<md-icon v-if="checkAssets" class="icon-4-feedback absolute pt-2 ml-16em">check_circle</md-icon>
				</div>
				<div class="text-secondary mb-3">
					Download example <a href="./../../template-xlsx/EXAMPLE_XML_LYRIC_FILE.xml" download>{{ $t('.XML') }}</a> or <a href="./../../template-xlsx/EXAMPLE_JSON_LYRIC_FILE.json" download>{{ $t('.JSON') }}</a> file
				</div>
			<div class="d-flex">
				<!-- form loop -->
				<md-switch
					class="md-primary mt-0 mb-3 mr-3"
					v-model="mediaLoop">
					{{ $t('Loop') }}
				</md-switch>
				<!-- form Mute -->
				<!-- video volume -->
				<div class="d-flex" @mouseover="hoverVolume = true" @mouseleave="hoverVolume = false">
					<i class="material-icons font20 mr-2 pointer" v-if="mediaVolume !== 0" @click="muteMedia">volume_up</i>
					<i class="material-icons font20 mr-2 pointer" v-if="mediaVolume === 0" @click="unMuteMedia">volume_off</i>
					<vue-slider
					v-show="hoverVolume"
					:process-style="{ backgroundColor: '#FFBF44' }"
					:tooltip-style="{ backgroundColor: '#FFBF44', borderColor: '#FFBF44', color: 'black' }"
					class="absolute pr-2 slidevolume"
					v-model="mediaVolume"
					:width="60"
					@dragging="hoverVolume = true"
					></vue-slider>
				</div>
			</div>
			<custom-input class="mb-3"
				align="left"
				:label="$t('Label')"
				:max="40"
				:restrictChar="true"
				:required="isRequired"
				v-model="mediaLabel"
				 />
			<!-- in / out video -->
			<div class="row row-thin pr-0 mr-0 pl-0" :class="{'disabled': !isUploading && !mediaFile && !media && !mediaUrl }">
				<div class="col-md-6 pr-0 mr-0">
					<custom-input
						type="duration-timer"
						align="left"
						:maxTime="mediaInMaxDuration"
						:minTime="'0'"
						:label="$t('In Point')"
						:required="isRequired"
						v-model="inPoint"
					/>
				</div>
				<div class="form-group mb-3 col-md-6 pr-0 mr-0">
					<custom-input
						type="duration-timer"
						align="left"
						:minTime="'1'"
						:maxTime="mediaMaxDuration"
						:label="$t('Out Point')"
						:required="isRequired"
						
						v-model="outPoint"
					/>
				</div>
			</div>
			<div class="row row-thin pr-0 mr-0 pl-0 mb-4">
				<div class="col-md-6 pr-0 mr-0">
				<custom-input
					type="number"
					field="index"
					:label="$t('Layer')"
					:required="isRequired"
					:max="100"
					:index-duplicated="isIndexDuplicated"
					
					v-model="mediaLayerIndex"
				/>
			</div>
		</div>
		<!-- lyric style -->
		<div class="form-group mt-3">
			<label class="text-primary">{{ $t('Lyric Style') }}</label>
			<div class="row row-thin">
				<!-- color -->
				<div class="col-md-6 mr-0 pr-1">
					<!-- Color -->
					<custom-input
						:class="{disabledlyric: !checkAssets}"
						class="mb-3"
						type="color"
						align="left"
						:label="$t('Color')"
						:required="isRequired"
						v-model="color"
						
					/>
				</div>
				<!-- BG color -->
				<div class="col-md-6 pl-1">
					<!-- BG Color -->
					<custom-input
						:class="{disabledlyric: !checkAssets}"
						class="mb-3"
						type="color"
						align="left"
						picker-position="right"
						:label="$t('BG Color')"
						:required="isRequired"
						v-model="backgroundColor"
					/>
				</div>
				<div class="col-md-6 mb-3 mr-0 pr-1 w-100" :class="{disabled: !checkAssets}">
					<md-menu md-align-trigger md-direction="bottom-start" class="w-100" :md-active.sync="isToggleFont">
						<div md-menu-trigger class="w-100">
							<custom-input
								:class="{disabledlyric: !checkAssets}"
								v-if="fontStyle >= 0 && fontStyle !== ''"
								type="selectSearch"
								class="form-control cur-p relative"
								:label="$t('Font')"
								:value="labelFont"
								@remove="removeFont()"
								:showClose="true"
								:align="'left'"
							/>
							<div @click.stop="toggleFont">
								<custom-input
									v-click-outside="resetFont"
									v-if="fontStyle === ''"
									type="selectSearchEmpty"
									class="form-control cur-p relative capitalize"
									:label="$t('Font')"
									v-model="searchFont"
									:showClose="false"
									:align="'left'"
								/>
							</div>
						</div>
						<md-menu-content id="scrolls-style" class="assets-item-wrapper-list ">
							<md-menu-item class="assets-item-wrapper-list item-property-rundown" v-for="item in filteredFont" @click="fontStyle = parseInt(item.key)"
								:key="item.key">{{item.label}}
							</md-menu-item>
							<md-menu-item v-if="filteredFont.length <= 0" class="assets-item-wrapper-list item-property-rundown">
								Not available
							</md-menu-item>
						</md-menu-content>
					</md-menu>
				</div>
			</div>
		</div>
		<!-- on complete label -->
		<div class="mt-2">
				<div class="d-flex justify-content-between">
					<div>
						<label class="text-primary">{{ $t('On Complete') }}</label>
					</div>
				</div>
			</div>
			<!-- on complete controller -->
			<div :class="{'disabled': mediaLoop}">
				<md-menu
					:md-active.sync="isOnComplete"
					class="h-fc col-md-12 pr-0 pl-0"
					md-size="small"
					md-direction="top-start"
					md-align-trigger>
					<div v-if="selectedOnComplete"
						:class="{'disabled-item': mediaLoop}"
						class="form-control cur-p relative mb-4"
						md-menu-trigger>
						<item-option
							:item="selectedOnComplete"
							v-if="selectedOnComplete"
						/>
						<div class="text-right">
							<div @click.stop="removeOnComplete" class="modal-close-assets absolute delete-complete-add">
								<i class="material-icons">cancel</i>
							</div>
						</div>
					</div>
					<div v-else md-menu-trigger>
						<input
							:class="{'disabled-item': mediaLoop}"
							type="text"
							class="form-control mb-4"
							:placeholder="$t('Stop (default)')"
							v-model="keywordSearchOnComplete"
							@click.stop="toggleOnComplete"
						/>
						<item-option
							:item="selectedOnComplete"
							v-if="selectedOnComplete"
						/>
					</div>
					<md-menu-content id="scrolls-style"
					:class="{'macro-content-wrapper-list': filteredParent.length > 6, 'assets-wrapper-list-empty': filteredParent.length === 0,
						'assets-wrapper-list-1': filteredParent.length === 1, 'assets-wrapper-list-2': filteredParent.length === 2,
						'assets-wrapper-list-3': filteredParent.length === 3, 'assets-wrapper-list-4': filteredParent.length === 4,
						'assets-wrapper-list-5': filteredParent.length === 5, 'assets-wrapper-list-6': filteredParent.length === 6,
						}"
						>
						<md-menu-item class="item-macros-rundown macro-content-wrapper-list"
							v-for="rundownItem in filteredParent"
							:key="rundownItem.id"
							@click="selectOnComplete(rundownItem)">
							<item-option :item="rundownItem" />
						</md-menu-item>
						<md-menu-item v-if="filteredParent.length <= 0" class="item-macros-rundown macro-content-wrapper-list">
							Oops, there is no assets available
						</md-menu-item>
					</md-menu-content>
				</md-menu>
			</div>
			<!-- parent controller -->
			<div class="mt-2">
				<div class="d-flex justify-content-between">
					<div>
						<label class="text-primary">{{ $t('Parent Controller') }}</label>
					</div>
					<div class="ml-0 pl-0">
						<md-switch
							class="md-primary mt-0 mb-2 mr-0"
							v-model="isParent">
						</md-switch>
					</div>
				</div>
			</div>
			<div class="d-flex select ">
				<!-- new dropdown select assets -->
				<md-menu
					:md-active.sync="isToggleParent"
					class="h-fc mr-2 w-100"
					md-size="small"
					md-direction="bottom-start"
					md-align-trigger>
					<div v-if="selectedParent"
						class="form-control cur-p relative w-100"
						md-menu-trigger>
						<item-option
							:item="selectedParent"
							v-if="selectedParent"
						/>
						<div @click.stop="removeParent" class="modal-close-assets absolute delete-assets-add">
							<i class="material-icons">cancel</i>
						</div>
					</div>
					<div v-else md-menu-trigger>
						<input
							type="text"
							class="form-control w-100"
							:placeholder="$t('Search or Select Parent Item')"
							v-model="keywordSearchParent"
							@click.stop="toggleParent"
						/>
						<item-option
							:item="selectedParent"
							v-if="selectedParent"
						/>
					</div>
					<md-menu-content id="scrolls-style" class="macro-content-wrapper-list">
						<md-menu-item class="item-macros-rundown macro-content-wrapper-list"
							v-for="rundownItem in filteredParent"
							:key="rundownItem.id"
							@click="selectParent(rundownItem)">
							<item-option :item="rundownItem" />
						</md-menu-item>
						<md-menu-item v-if="filteredParent.length <= 0" class="item-macros-rundown macro-content-wrapper-list">
							Oops, there is no assets available
						</md-menu-item>
					</md-menu-content>
				</md-menu>
				<!-- delay -->
				<div class="select">
					<custom-input
						class="form-input mb-3"
						type="number"
						:label="$t('Delay')"
						:min="-15000"
						:max="15000"
						:step="100"
						:suffix="'ms'"
						v-model="childOrder"
						@keyenter="onInputEnter('delay', ...arguments)"
						:allowNegative="true"
					/>
				</div>
			</div>
			<div class="d-flex mt-4">
				<button @click="saveMedia(null, true)"
					:class="{ 'is-loading': isSaving }"
					class="btn btn-primary btn-sm mr-2">
					{{ $t('Save Changes') }}
				</button>
				<button @click="closeForm()"
					class="btn btn-secondary btn-sm">
					{{ $t('Cancel') }}
				</button>
			</div>	
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import ClickOutside from 'vue-click-outside';
import { mapGetters } from 'vuex';
import localforage from 'localforage';
import checkIcon from 'vue-material-design-icons/CheckCircle.vue';
import musicIcon from 'vue-material-design-icons/Music.vue';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import ItemOption from '@/components/ItemOption.vue';
import {
	getAxiosErrorMessage,
	duplicateVar,
	delay,
	getVideoBlob,
} from '@/lib/helper';
import rundownItemsApi from '@/api/rundownItems';
import fileApi from '@/api/file';
import mediasApi from '@/api/medias';
import CustomInput from '@/components/CustomInput.vue';
import {
	delayList,
	fontOptions,
} from '@/lib/statics';

export default {
	name: 'LottieProperty',
	props: {
		data: {
			type: Object,
		},
		rundown: {
			type: Object,
		},
		media: {
			type: Object,
		},
		filteredItems: {
			type: Array,
		},
		items: {
			type: Array,
			default: () => [],
		},
	},
	directives: {
		ClickOutside,
	},
	data() {
		return {
			mediaId: '',
			mediaFile: '',
			mediaUrl: '',
			mediaLabel: '',
			mediaLoop: false,
			mediaMute: false,
			mediaLayerIndex: 0,
			mediaType: 'audio',
			progress: 0,
			isUploading: false,
			isSaving: false,
			isVisible: true,
			isLoading: false,
			isRequired: false,
			mediaProgress: 0,
			isAudioAdding: false,
			uploadLimit: '',
			isEnableUploadLimit: false,
			settings: null,
			fileSize: '',
			isActiveEdit: false,
			mediaAssetLabel: '',
			mediaAsset: '',
			extractedLyric: '',
			isUploadingAsset: '',
			backgroundColor: '#2c2a2a52',
			color: '#FFFFFFFF',
			searchFont: '',
			fontOptions,
			fontStyle: 14,
			isToggleFont: false,
			// loader
			fullPage: true,
			colorOverlay: '#000000',
			colorLoading: '#FFFFFF',
			userClient: {},
			hasPlayed: false,
			parentItem: null,
			isParent: false,
			delayList,
			childOrder: 0,
			isCaching: false,
			isCached: false,
			selectedParent: null,
			selectedOnComplete: null,
			keywordSearchParent: '',
			keywordSearchOnComplete: '',
			isToggleParent: false,
			isOnComplete: false,
			// storage warn
			isStorage99Percent: false,
			isStorage80Percent: false,
			outPoint: '00:00:00',
			inPoint: '00:00:00',
			mediaDuration: '',
			mediaVolume: 100,
			hoverVolume: false,
		};
	},
	components: {
		CustomInput,
		Loading,
		ItemOption,
		checkIcon,
		musicIcon,
		VueSlider,
	},
	methods: {
		closeForm() {
			this.$emit('close');
		},
		toggleParent() {
			this.isToggleParent = true;
		},
		toggleOnComplete() {
			this.isOnComplete = true;
		},
		onCancel() {
			if (this.cancelUpload) {
				this.cancelUpload();
				this.mediaFile = null;
				this.isCaching = false;
				this.isCached = false;
				this.isUploading = false;
			}
		},
		updateActiveEdit() {
			this.isSaving = true;
			const callback = (response) => {
				const item = response.data;
				this.$emit('add', item);
				this.isSaving = false;
			};
			const errorCallback = () => {
				this.isSaving = false;
			};
			const params = {
				active_edit: null,
			};
			rundownItemsApi.update(this.data.id, params, callback, errorCallback);
		},
		playPreview() {
			if (this.data.is_Locked) return; // Disable when ed
			const id = this.data.id;
			const status = 'preview';
			// eslint-disable-next-line no-unused-vars
			const callback = (response) => {
				// const items = response.data;
			};
			const errorCallback = () => {
			};
			const userActivateAllItem = this.userSettings && this.userSettings.is_enable_all_preview ? this.userSettings.is_enable_all_preview : false;
			const params = {
				isAllItem: userActivateAllItem,
			};
			rundownItemsApi.togglePlay(id, status, params, callback, errorCallback);
		},
		initDataUser() {
			if (this.user) {
				const settingsString = this.user && this.user.settings ? this.user.settings : '';
				const settings = JSON.parse(settingsString);
				this.settings = settings;
				// const roles = this.user && this.user.roles ? this.user.roles : [];
				const isSuperAdmin = this.isSuperAdmin || null;// check the computed import the getters befor implement
				const isCollaborator = this.isCollaborator || null;// check the computed import the getters befor implement
				const isClient = this.isClient || null;// check the computed import the getters befor implement
				if (!isSuperAdmin && isClient) { // not admin and can be collaborator and client who have two roles
					this.isEnableUploadLimit = settings
					&& settings.subscription
					&& settings.subscription.storage
					&& settings.subscription.storage.is_enabled ? duplicateVar(settings.subscription.storage.is_enabled) : false;
					this.uploadLimit = settings
					&& settings.subscription
					&& settings.subscription.storage
					&& settings.subscription.storage.upload_size ? duplicateVar(settings.subscription.storage.upload_size) : 10;
				} else if ((!isSuperAdmin && isCollaborator && !isClient)) { // only for collaborator that invited by client
					if (this.localClientUser) {
						const userClientSettingsString = this.localClientUser && this.localClientUser.settings ? this.localClientUser.settings : '';
						const userClientSettings = JSON.parse(userClientSettingsString);
						this.isEnableUploadLimit = userClientSettings
						&& userClientSettings.subscription
						&& userClientSettings.subscription.storage
						&& userClientSettings.subscription.storage.is_enabled ? duplicateVar(userClientSettings.subscription.storage.is_enabled) : false;
						this.uploadLimit = userClientSettings
						&& userClientSettings.subscription
						&& userClientSettings.subscription.storage
						&& userClientSettings.subscription.storage.upload_size ? duplicateVar(userClientSettings.subscription.storage.upload_size) : 10;
					}
				} else { // for superadmin only
					this.isEnableUploadLimit = false;
					this.uploadLimit = 1048;
				}
			}
		},
		initData() {
			this.reset();
			if (this.data) {
				let content = this.data.content;
				if (typeof content === 'string') {
					content = JSON.parse(content);
					this.contentAsset = content;
				}
				const activeEdit = this.data.active_edit;
				if (activeEdit && activeEdit !== this.userId) {
					this.isActiveEdit = true;
				}
				this.mediaLabel = this.data.name;
				this.mediaLayerIndex = this.data.layer_index;
				if (content) {
					const itemKey = `audio_${content.id}`;
					this.checkCached(itemKey);
					this.mediaAsset = content.assetsURL;
					this.extractedLyric = content.extractedLyric;
					this.mediaUrl = content.url;
					this.mediaId = content.id;
					this.mediaAssetLabel = content.mediaAssetLabel;
					this.mediaType = content.type;
					this.mediaLoop = content.loop;
					this.mediaMute = content.muted;
					this.color = content.color || '#FFFFFFFF';
					this.backgroundColor = content.backgroundColor || '#2c2a2a52';
					this.fontStyle = content.fontStyle || 14;
					this.hasPlayed = content.hasPlayed;
					this.isParent = content.isParent || false;
					this.selectedParent = this.filteredParent.find(item => item.id === content.parentItem) || '';
					this.selectedOnComplete = this.filteredParent.find(item => item.id === content.onCompleteItem) || '';
					this.childOrder = content.childOrder || 0;
					if (content.duration) this.duration = content.duration;
					if (content.inPoint) this.inPoint = content.inPoint || '00:00:00';
					if (content.outPoint) this.outPoint = content.outPoint || this.getExistingOldDuration;
					if (content.volume) this.mediaVolume = content.volume;
				}
			}
		},
		reset() {
			this.mediaId = '';
			this.mediaFile = '';
			this.mediaUrl = '';
			this.mediaType = 'audio';
			this.mediaLoop = false;
			this.mediaMute = false;
			this.mediaLabel = '';
			this.mediaLayerIndex = 0;
			this.hasPlayed = false;
			this.inPoint = '00:00:00';
			this.outPoint = '00:00:01';
			this.mediaVolume = 100;
			this.mediaAssetLabel = '';
			this.extractedLyric = '';
			this.color = '#FFFFFFFF';
			this.backgroundColor = '#2c2a2a52';
			this.fontStyle = 14;
		},
		onMediaSelected(e) {
			this.initDataUser();
			// get data max upload
			const oneMB = 1048576; // MB
			if (!this.isEnableUploadLimit) {
				this.uploadLimit = 1048; // limit 1 gb
			}
			let files = e.target.files;
			const fileSizeInMb = files[0].size / oneMB;
			const oneGB = 1048;
			if (files.length > 0) {
				if (files[0].type === 'audio/mpeg' || files[0].type === 'audio/wav' || files[0].type === 'audio/ogg') {
					if (fileSizeInMb <= oneGB) {
						if (fileSizeInMb <= this.uploadLimit) {
							if (this.rundownStorage && !this.isSuperAdmin) {
								const isRemainingStorageAvailable = this.rundownStorage.total_remaining_size >= 0 && this.rundownStorage.total_remaining_size >= (files[0].size / oneMB);
								const nomalizedTotalRemaining = this.rundownStorage.total_remaining_size <= 0 ? 0 : this.rundownStorage.total_remaining_size;
								if (!isRemainingStorageAvailable) {
									const message = `Your total used Storage is ${this.rundownStorage.total_used_file_size} MB, your currennt remaining size is ${nomalizedTotalRemaining.toFixed(2)}MB`;
									this.$notify({
										group: 'app',
										type: 'warning',
										title: 'Upload Media',
										text: message,
									});
									files = null;
									this.isCached = false;
									this.isCaching = false;
									if (document.querySelector('#audioInputMp')) document.querySelector('#audioInputMp').value = '';
									return;
								}
							// eslint-disable-next-line no-else-return
							}
							const file = files[0];
							if (!file) {
								this.$notify({
									group: 'app',
									type: 'warn',
									title: 'Upload Media',
									text: 'Sorry, currently we cant upload the file',
								});
								return;
							}
							this.isUploading = true;
							const params = new FormData();
							params.append('file', file);
							if (this.rundown && this.rundown.id) params.append('rundown_id', this.rundown.id);
							const audio = document.createElement('audio');
							audio.preload = 'metadata';
							audio.onloadedmetadata = () => {
								this.duration = audio.duration;
								const duration = audio.duration;
								// get range duration
								const hours = (duration / 3600 >= 1) ? parseInt(duration / 3600) : 0;
								const minutes = parseInt(parseInt(duration % 3600) / 60);
								const seconds = parseInt(duration % 60);
								const hoursLabel = hours < 10 ? `0${hours}` : hours;
								const minutesLabel = minutes < 10 ? `0${minutes}` : minutes;
								const secondsLabel = seconds < 10 ? `0${seconds}` : seconds;
								const durationLabel = `${hoursLabel}:${minutesLabel}:${secondsLabel}`;
								this.mediaDuration = durationLabel;
								// reset value to default if user change the media
								this.inPoint = '00:00:00';
								this.outPoint = durationLabel;
							};
							audio.src = URL.createObjectURL(file);
							const callback = (response) => {
								const mediaUrl = response.data;
								this.mediaUrl = mediaUrl;
								this.hasPlayed = false;
								this.isUploading = false;
								this.mediaProgress = 0;
								if (document.querySelector('#audioInputMp')) document.querySelector('#audioInputMp').value = '';
								this.addMedia(file, this.mediaUrl, file.size / 1048576, this.duration);
							};
							if (this.rundownStorage) {
								// on the spot 100%
								const resultSizeFile = file.size / oneMB;
								// eslint-disable-next-line
								const isStorageOnTheSpot100 = this.rundownStorage.total_remaining_size == resultSizeFile;
								if (isStorageOnTheSpot100) {
									const message = 'Your total used Storage is 100%';
									this.$notify({
										group: 'app',
										type: 'warning',
										title: 'Upload Media',
										text: message,
									});
								}
								// right on 80% mark
								const resultPercentage80 = this.rundownStorage.total_max_file_size * 80 / 100;
								const fixTotalUsageAndFile80 = (this.rundownStorage.total_used_file_size + resultSizeFile).toFixed(4);
								// eslint-disable-next-line
								const isStorageOnTheSpot80 = fixTotalUsageAndFile80 >= resultPercentage80 && this.rundownStorage.total_used_file_size < resultPercentage80;
								if (isStorageOnTheSpot80) {
									const message = 'Your total used Storage is over 80%';
									this.$notify({
										group: 'app',
										type: 'warning',
										title: 'Upload Media',
										text: message,
									});
									this.isStorage80Percent = true;
									this.currentStorage = this.rundownStorage.total_max_file_size - resultPercentage80;
									this.availableStorage = this.rundownStorage.total_max_file_size;
								}
								// right on 99% mark
								const resultPercentage99 = this.rundownStorage.total_max_file_size * 99 / 100;
								const fixTotalUsageAndFile99 = (this.rundownStorage.total_used_file_size + resultSizeFile).toFixed(4);
								// eslint-disable-next-line
								const isStorageOnTheSpot99 = fixTotalUsageAndFile99 >= resultPercentage99 && this.rundownStorage.total_used_file_size < resultPercentage99;
								if (isStorageOnTheSpot99) {
									const message = 'Your total used Storage is over 99%';
									this.$notify({
										group: 'app',
										type: 'warning',
										title: 'Upload Media',
										text: message,
									});
									this.isStorage99Percent = true;
									this.currentStorage = this.rundownStorage.total_max_file_size - resultPercentage99;
									this.availableStorage = this.rundownStorage.total_max_file_size;
								}
							}
							const errorCallback = (e) => {
								const messageFromCallback = getAxiosErrorMessage(e);
								const message = messageFromCallback && messageFromCallback !== '' ? messageFromCallback : 'Error when uploading file';
								this.$notify({
									group: 'app',
									type: 'error',
									title: 'Upload Media',
									text: message,
									duration: 999999999,
								});
								this.isUploading = false;
								this.mediaLabel = '';
								this.mediaFile = '';
								this.mediaUrl = '';
								this.isUploadingAsset = false;
								this.inPoint = '00:00:00';
								this.outPoint = '00:00:00';
								this.isCaching = false;
								this.isCached = false;
							};
							const progressCallback = (progress) => {
								this.mediaProgress = progress;
							};
							const cancelUploadCallback = (c) => {
								this.cancelUpload = c;
							};
							fileApi.upload(params, callback, errorCallback, progressCallback, cancelUploadCallback);
							this.mediaFile = file;
							// Remove extension from filename to set label
							let filename = duplicateVar(file.name);
							filename = filename.split('.').slice(0, -1).join('.');
							this.mediaLabel = duplicateVar(filename);
							if (document.querySelector('#audioInputMp')) document.querySelector('#audioInputMp').value = '';
						} else {
							files = null;
							this.isCached = false;
							this.isCaching = false;
							if (document.querySelector('#audioInputMp')) document.querySelector('#audioInputMp').value = '';
							const appUrl = process.env.VUE_APP_URL;
							this.$notify({
								group: 'app',
								type: 'error',
								text: `You current package upload limit is ${this.uploadLimit} MB, <a href="${appUrl}/settings?menu=subscribe"> Upgrade your subscription </a>`,
							});
						}
					} else {
						files = null;
						this.isCached = false;
						this.isCaching = false;
						if (document.querySelector('#audioInputMp')) document.querySelector('#audioInputMp').value = '';
						this.$notify({
							group: 'app',
							type: 'error',
							text: 'Max upload limit is 1GB',
						});
					}
				} else {
					this.$notify({
						group: 'app',
						type: 'warning',
						title: 'Upload Media',
						text: 'Unsupported file',
					});
					// eslint-disable-next-line
					return;
				}
			}
		},
		onMediaSelectedLyric(e) {
			this.initDataUser();
			const oneMB = 1048576; // MB
			if (!this.isEnableUploadLimit) {
				this.uploadLimit = 1048; // make it "1gb" when no limiter is set
			}
			let files = e.target.files;
			const fileSizeInMb = files[0].size / oneMB;
			const oneGB = 1048;
			if (files.length > 0) {
				if (files[0].type.includes('json') || files[0].type.includes('xml')) {
					if (fileSizeInMb <= oneGB) {
						if (fileSizeInMb <= this.uploadLimit) {
						// check storage
							if (this.rundownStorage && !this.isSuperAdmin) {
								const isRemainingStorageAvailable = this.rundownStorage.total_remaining_size >= 0 && this.rundownStorage.total_remaining_size >= (files[0].size / oneMB);
								const nomalizedTotalRemaining = this.rundownStorage.total_remaining_size <= 0 ? 0 : this.rundownStorage.total_remaining_size;
								if (!isRemainingStorageAvailable) {
									const message = `Your total used Storage is ${this.rundownStorage.total_used_file_size} MB, your currennt remaining size is ${nomalizedTotalRemaining.toFixed(2)}MB`;
									this.$notify({
										group: 'app',
										type: 'warning',
										title: 'Upload Lyric',
										text: message,
									});
									files = null;
									this.isCached = false;
									this.isCaching = false;
									if (document.querySelector('#audioLyricInput')) document.querySelector('#audioLyricInput').value = '';
									return;
								}
								// eslint-disable-next-line no-else-return
							}
							const file = files[0];
							if (!file) {
								this.$notify({
									group: 'app',
									type: 'warn',
									title: 'Upload Lyric',
									text: 'Sorry, currently we cant upload the file',
								});
								return;
							}
							this.isUploadingAsset = true;
							const params = new FormData();
							params.append('file', file);
							if (this.rundown && this.rundown.id) params.append('rundown_id', this.rundown.id);
							this.fileSize = files.size / oneMB;
							const callback = (response) => {
								const mediaAsset = response.data;
								this.mediaAsset = mediaAsset;
								this.mediaProgressAsset = 0;
								// if upload success then get the json/xml file and save to extractedLyric in content assets (audio)
								axios
									.get(mediaAsset)
									.then((response) => {
										// if file is json
										if (response.data && response.data.lyric) {
											this.extractedLyric = response.data && response.data.lyric ? response.data.lyric : '-';
											// if file is xml
										} else if (response.data && response.data.includes('</lyric>')) {
											const result = response.data;
											result.replace('<lyric>', '');
											result.replace('</lyric>', '');
											this.extractedLyric = result;
											// if file has wrong format, does not match the existing template
										} else {
											this.extractedLyric = '-';
										}
										// then save extractedLyric on content assets (audio)
										this.saveMedia(null, false);
									})
									.catch(() => {
										// show toaster error upload
										this.$notify({
											group: 'app',
											type: 'error',
											title: 'Upload Lyric',
											text: 'Looks like you uploaded .XML / .JSON with the wrong format',
										});
										if (document.querySelector('#audioLyricInput')) document.querySelector('#audioLyricInput').value = '';
										this.mediaAssetLabel = '';
									});
								this.isUploadingAsset = false;
							};
							const errorCallback = (e) => {
								const message = getAxiosErrorMessage(e);
								this.$notify({
									group: 'app',
									type: 'error',
									title: 'Upload Media',
									text: message,
								});
								this.isUploadingAsset = false;
							};
							const progressCallback = (progress) => {
								this.mediaProgressAsset = progress;
							};
							const cancelUploadCallback = (c) => {
								this.cancelUpload = c;
							};
							fileApi.upload(params, callback, errorCallback, progressCallback, cancelUploadCallback);
							// Remove extension from filename to set label
							let filename = duplicateVar(file.name);
							filename = filename.split('.').slice(0, -1).join('.');
							this.mediaAssetLabel = duplicateVar(filename);
						} else {
							files = null;
							this.isCached = false;
							this.isCaching = false;
							if (document.querySelector('#audioLyricInput')) document.querySelector('#audioLyricInput').value = '';
							const appUrl = process.env.VUE_APP_URL;
							this.$notify({
								group: 'app',
								type: 'error',
								text: `You current package upload limit is ${this.uploadLimit} MB, <a href="${appUrl}/settings?menu=subscribe"> Upgrade your subscription </a>`,
							});
						}
					} else {
						files = null;
						this.isCached = false;
						this.isCaching = false;
						if (document.querySelector('#audioLyricInput')) document.querySelector('#audioLyricInput').value = '';
						this.$notify({
							group: 'app',
							type: 'error',
							text: 'Max upload limit is 1GB',
						});
					}
				} else {
					this.$notify({
						group: 'app',
						type: 'warning',
						title: 'Upload Media',
						text: 'Unsupported file',
					});
					// eslint-disable-next-line
					return;
				}
			}
		},
		cacheDisplays() {
			const callback = () => {
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Media Saved',
					text: `Rebuilding cache for ${this.data.name}`,
				});
			};
			const callbackError = () => {
			};
			const params = {
				display_name: '',
			};
			rundownItemsApi.cacheDisplay(this.data.id, params, callback, callbackError);
		},
		saveMedia(isSame = true, isClose = true) {
			this.isSaving = true;
			this.hoverVolume = false;
			const callback = (response) => {
				const item = response.data;
				this.$emit('add', item);
				this.isSaving = false;
				this.isMediaFormVisible = false;
				if (!isSame) this.cacheDisplays();
				if (isClose) this.closeForm();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Media',
					text: message,
				});
				this.isSaving = false;
				if (isClose) this.closeForm();
			};
			if (this.data) {
				rundownItemsApi.update(this.data.id, this.params, callback, errorCallback);
			} else {
				rundownItemsApi.create(this.params, callback, errorCallback);
			}
		},
		addMedia(file, mediaUrl, sizeAudio, durationAudio) {
			// this.isAdding = true;
			this.isAudioAdding = true;
			const params = {
				name: this.mediaLabel,
				path: this.mediaUrl,
				type: 'audio',
				duration: durationAudio,
				rundown_id: this.rundown.id || null,
				category_id: 1,
				size: sizeAudio,
			};
			// eslint-disable-next-line no-unused-vars
			const callback = (response) => {
				const item = response.data;
				this.mediaId = item.id;
				const isSame = false;
				const blob = new Blob([file]);
				const mediaKey = `audio_${this.mediaId}`;
				localforage.setItem(mediaKey, blob, (err) => {
					if (!err) {
						this.isCaching = false;
						this.isCached = true;
						this.$notify({
							group: 'app',
							type: 'success',
							title: 'Media Saved',
							text: 'Media is cached',
						});
					}
				});
				this.saveMedia(isSame, false);
				this.isAudioAdding = false;
				if (this.isStorage80Percent || this.isStorage99Percent) this.notifyEmailStorage();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Media',
					text: message,
				});
				this.isAudioAdding = false;
				this.availableStorage = 0;
				this.currentStorage = 0;
				this.isCaching = false;
				this.isCached = false;
				// this.isAdding = false;
			};
			mediasApi.create(params, callback, errorCallback);
		},
		notifyEmailStorage() {
			const callback = () => {
				this.availableStorage = 0;
				this.currentStorage = 0;
				this.isStorage99Percent = false;
				this.isStorage80Percent = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Media',
					text: message,
				});
			};
			const params = {
				current_storage: this.currentStorage,
				available_storage: this.availableStorage,
			};
			mediasApi.notifyEmail(params, callback, errorCallback);
		},
		onKeywordChange() {
			delay(() => {
			}, 1200);
		},
		checkDuplicateIndex() {
			const valueArr = this.filteredItems.map(a => a.layer_index);
			let count = 0;
			for (let i = 0; i < valueArr.length; ++i) {
				if (valueArr[i] === this.mediaLayerIndex) count++;
			}
			if (count > 1) {
				return true;
			}
			return false;
		},
		duplicateLayerText() {
			const text1 = 'Other item also using this layer, only one item at a time will be displayed';
			return text1;
		},
		deactiveTemplateProperty() {
			this.isMediaAsset = false;
		},
		checkCached(itemKey) {
			localforage.getItem(itemKey).then((value) => {
				if (value) {
					let content = this.data.content;
					if (typeof content === 'string') {
						content = JSON.parse(content);
					}
					if (content.url) this.isCached = true;
				} else {
					this.isCached = false;
				}
			});
		},
		selectParent(item) {
			this.selectedParent = item;
			this.keywordSearchParent = '';
		},
		removeParent() {
			this.selectedParent = null;
			this.keywordSearchParent = '';
		},
		selectOnComplete(item) {
			this.selectedOnComplete = item;
			this.keywordSearchOnComplete = '';
		},
		removeOnComplete() {
			this.selectedOnComplete = null;
			this.keywordSearchOnComplete = '';
		},
		onInputEnter(props, value) {
			if (props === 'layer') this.mediaLayerIndex = value;
			if (props === 'delay') this.childOrder = value;
			if (props === 'inPoint') this.inPoint = value;
			if (props === 'outPoint') this.outPoint = value;
			if (props === 'volume') this.mediaVolume = value;
		},
		convertDecimalToTime(duration) {
			const hours = (duration / 3600 >= 1) ? parseInt(duration / 3600) : 0;
			const minutes = parseInt(parseInt(duration % 3600) / 60);
			const seconds = parseInt(duration % 60);
			const hoursLabel = hours < 10 ? `0${hours}` : hours;
			const minutesLabel = minutes < 10 ? `0${minutes}` : minutes;
			const secondsLabel = seconds < 10 ? `0${seconds}` : seconds;
			const durationLabel = `${hoursLabel}:${minutesLabel}:${secondsLabel}`;
			return durationLabel;
		},
		getMediaDuration(audioBlob) {
			const audio = new Audio(audioBlob);
			const audioPreview = document.createElement('audio');
			audioPreview.preload = 'metadata';
			audioPreview.onloadedmetadata = () => {
				window.URL.revokeObjectURL(audio.src);
				const duration = audioPreview.duration;
				this.duration = duration;
				// get range duration
				const hours = (duration / 3600 >= 1) ? parseInt(duration / 3600) : 0;
				const minutes = parseInt(parseInt(duration % 3600) / 60);
				const seconds = parseInt(duration % 60);
				const hoursLabel = hours < 10 ? `0${hours}` : hours;
				const minutesLabel = minutes < 10 ? `0${minutes}` : minutes;
				const secondsLabel = seconds < 10 ? `0${seconds}` : seconds;
				const durationLabel = `${hoursLabel}:${minutesLabel}:${secondsLabel}`;
				this.mediaDuration = durationLabel;
				// reset value to default if user change the media
				this.outPoint = this.mediaDuration;
				this.inPoint = '00:00:00';
				this.saveMedia(null, false);
			};
			audioPreview.src = URL.createObjectURL(audioBlob);
		},
		async checkMediaCached(key, path) {
			// cheking media cache
			this.isCaching = true;
			this.isCached = false;
			localforage.getItem(key).then(async (value) => {
				if (!value) {
					const audioBlob = await getVideoBlob(path).catch(() => {
						this.isCaching = false;
						this.isCached = false;
					});
					localforage.setItem(key, audioBlob, (err) => {
						if (!err) {
							this.isCaching = false;
							this.isCached = true;
							this.$notify({
								group: 'app',
								type: 'success',
								title: 'Media Saved',
								text: 'Media is cached',
							});
						} else {
							this.isCaching = false;
							this.isCached = false;
						}
						// this.checkVideoSpec(value);
						this.getMediaDuration(audioBlob);
					});
				}
			});
			this.checkCached(key);
		},
		openGallery() {
			this.$emit('browse');
		},
		toggleFont() {
			this.isToggleFont = true;
		},
		resetFont() {
			this.searchFont = '';
		},
		removeFont() {
			this.fontStyle = 14;
		},
		muteMedia() {
			this.mediaMute = true;
			this.mediaVolume = 0;
		},
		unMuteMedia() {
			this.mediaMute = false;
			this.mediaVolume = 100;
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			clientUser: 'clientUser',
			isClient: 'isClient',
			isSuperAdmin: 'isSuperAdmin',
			isCollaborator: 'isCollaborator',
		}),
		filteredParent() {
			const filteredParent = this.items.filter(item => item.id !== this.data.id);
			let finalResult = filteredParent.filter(item => item.type !== 'separator');
			if (this.keywordSearchParent) {
				finalResult = finalResult.filter(item => item.name.toUpperCase().includes(this.keywordSearchParent.toUpperCase()));
				return finalResult;
			}
			if (this.keywordSearchOnComplete) {
				finalResult = finalResult.filter(item => item.name.toUpperCase().includes(this.keywordSearchOnComplete.toUpperCase()));
				return finalResult;
			}
			return finalResult;
		},
		userId() {
			const userId = this.user && this.user.id ? this.user.id : null;
			return userId;
		},
		userSettings() {
			const settings = this.user && this.user.settings ? JSON.parse(this.user.settings) : null;
			return settings;
		},
		params() {
			const mediaLabel = this.mediaLabel.trim();
			// const parentItemId = this.parentItem && this.parentItem.id ? this.parentItem.id : null;
			const parentItemId = this.selectedParent && this.selectedParent.id ? this.selectedParent.id : null;
			const onCompleteItemId = this.selectedOnComplete && this.selectedOnComplete.id ? this.selectedOnComplete.id : null;

			const content = {
				id: this.mediaId,
				assetsURL: this.mediaAsset,
				url: this.mediaUrl,
				type: this.mediaType,
				loop: this.mediaLoop,
				label: mediaLabel,
				hasPlayed: this.hasPlayed,
				isParent: this.isParent,
				parentItem: parentItemId,
				onCompleteItem: onCompleteItemId,
				mediaAssetLabel: this.mediaAssetLabel,
				childOrder: this.childOrder,
				inPoint: this.inPoint || '00:00:00',
				outPoint: this.outPoint || this.mediaDuration || this.getExistingOldDuration,
				duration: this.duration,
				muted: this.mediaMute,
				volume: this.mediaVolume,
				extractedLyric: this.extractedLyric,
				fontStyle: this.fontStyle,
				backgroundColor: this.backgroundColor,
				color: this.color,
			};
			const contentString = JSON.stringify(content);
			const params = {
				name: mediaLabel || 'Default Audio',
				type: 'audio',
				content: contentString,
				layer_index: this.mediaLayerIndex,
				rundown_id: this.rundownId,
			};
			if (!this.data.active_edit) {
				params.active_edit = this.userId;
			}
			return params;
		},
		rundownStorage() {
			return {
				total_max_file_size: this.rundown && this.rundown.total_max_file_size ? this.rundown.total_max_file_size : 0,
				total_remaining_size: this.rundown && this.rundown.total_remaining_size ? this.rundown.total_remaining_size : 0,
				total_used_file_size: this.rundown && this.rundown.total_used_file_size ? this.rundown.total_used_file_size : 0,
			};
		},
		rundownId() {
			return this.rundown ? this.rundown.id : 0;
		},
		isIndexDuplicated() {
			if (this.data) {
				// eslint-disable-next-line
				const filter = (({ id, layer_index }) => id !== this.data.id && layer_index === this.mediaLayerIndex);
				const duplicateItems = this.items.filter(filter);
				return duplicateItems.length > 0;
			}
			return false;
		},
		isLocked() {
			const index = this.items.findIndex(({ id }) => id === this.data.id);
			return this.items[index];
		},
		content() {
			let content = null;
			if (this.data) {
				content = this.data.content;
				if (typeof content === 'string') {
					content = JSON.parse(content);
				}
			}
			return content;
		},
		checkAssets() {
			return this.content && this.content.assetsURL ? this.content.assetsURL.length > 0 : false;
		},
		mediaInMaxDuration() {
			const hms = this.outPoint;// your input string
			const a = hms.split(':'); // split it at the colons
			const seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
			// return default value for temporary
			if (hms === '00:NaN:NaN') {
				return '00:00:00';
			}
			return JSON.stringify(seconds - 1);
		},
		mediaMaxDuration() {
			let duration = '00:00:05';
			if (this.content && this.content.duration) {
				duration = this.content.duration;
				return duration;
			}
			return duration;
		},
		getExistingOldDuration() {
			const duration = this.content && this.content.duration ? this.content.duration : '0';
			const hours = (duration / 3600 >= 1) ? parseInt(duration / 3600) : 0;
			const minutes = parseInt(parseInt(duration % 3600) / 60);
			const seconds = parseInt(duration % 60);
			const hoursLabel = hours < 10 ? `0${hours}` : hours;
			const minutesLabel = minutes < 10 ? `0${minutes}` : minutes;
			const secondsLabel = seconds < 10 ? `0${seconds}` : seconds;
			const durationLabel = `${hoursLabel}:${minutesLabel}:${secondsLabel}`;
			return durationLabel;
		},
		filteredFont() {
			if (this.searchFont) {
				return this.fontOptions.filter(item => item.label.toLowerCase().includes(this.searchFont));
			}
			return this.fontOptions;
		},
		labelFont() {
			let content = this.data.content;
			if (typeof content === 'string') {
				content = JSON.parse(content);
			}
			if (content && content.fontStyle >= 0) {
				const index = this.fontOptions.findIndex(({ key }) => key === JSON.stringify(content.fontStyle));
				if (index !== -1) return this.fontOptions[index].label;
			}
			return this.fontOptions[0].label;
		},
		isUserEditing() {
			const index = this.items.findIndex(({ id }) => id === this.data.id);
			return this.items[index] ? this.items[index].active_edit : null;
		},
	},
	watch: {
		fontStyle() {
			this.searchFont = '';
		},
		mediaFile() {
			const type = 'audio';
			this.mediaType = type;
		},
		data() {
			if (this.data) {
				this.mediaLayerIndex = this.data.layer_index;
				this.mediaLabel = this.data.name;
				let content = this.data.content;
				if (typeof content === 'string') {
					content = JSON.parse(content);
				}
				if (content) {
					this.mediaId = content.id;
					this.mediaUrl = content.url;
					// this.checkExist();
					const activeEdit = this.data.active_edit;
					if (activeEdit && activeEdit !== this.userId) {
						this.isActiveEdit = true;
					// this.initData();
					} else {
						this.isActiveEdit = false;
					}

					this.mediaAsset = content.assetsURL;
					this.mediaAssetLabel = content.mediaAssetLabel;
					this.extractedLyric = content.extractedLyric;
					this.mediaType = content.type;
					this.mediaLoop = content.loop;
					this.hasPlayed = content.hasPlayed;
					this.isParent = content.isParent;
					this.mediaMute = content.muted;
					this.mediaVolume = content.volume;
					this.selectedParent = this.filteredItems.find(item => item.id === content.parentItem) || '';
					this.selectedOnComplete = this.filteredParent.find(item => item.id === content.onCompleteItem) || '';
					this.childOrder = content.childOrder;
					this.inPoint = content.inPoint || '00:00:00';
					this.outPoint = content.outPoint || '00:00:01';
					if (content.duration) this.duration = content.duration;
					this.fontStyle = content.fontStyle;
					this.color = content.color || '#FFFFFFFF';
					this.backgroundColor = content.backgroundColor || '#2c2a2a52';
				}
			}
		},
		async media() {
			if (this.media) {
				const isSame = this.mediaId === this.media.id;
				this.mediaId = this.media.id;
				this.mediaUrl = this.media.path;
				this.mediaLabel = this.media.name;
				this.mediaType = this.media.type;
				this.outPoint = this.convertDecimalToTime(this.duration);
				this.saveMedia(isSame, false);
				const mediaKey = `audio_${this.mediaId}`;
				localforage.getItem(mediaKey).then((value) => {
					if (value) {
						// this.checkVideoSpec(value);
						this.getMediaDuration(value);
						this.isCached = true;
					} else {
						this.checkMediaCached(mediaKey, this.mediaUrl);
					}
				});
			}
		},
		mediaLoop() {
			if (this.mediaLoop) {
				this.selectedOnComplete = null;
			}
		},
		mediaVolume() {
			if (this.mediaVolume > 0) {
				this.mediaMute = false;
			} else {
				this.mediaMute = true;
			}
		},
	},
	beforeDestroy() {
		if (this.data.active_edit === this.userId) {
			this.updateActiveEdit();
		}
	},
	created() {
		if (this.clientUser) {
			this.localClientUser = this.clientUser;
		}
		this.isRequired = false;
		this.isLoading = true;
		this.$nextTick(() => {
			this.initData();
		});
		setTimeout(() => {
			this.isRequired = true;
			this.isLoading = false;
		}, 300);
		this.isCached = false;
	},
};
</script>
